
import { createSlice } from "@reduxjs/toolkit";
import { deleteAttendanceType, getAttendanceType } from "../action";

interface AttendanceType {
    _id: string;
    name: string;
    time: string;
    duration: string;
    bundleRules: string;
    bundling: string;
    leaveRules: string;
    targetService: string;
    ISPBillable: string;
    ispProgram: string;
    ISPData: string;
    totalUnits: string;
    billingDate: string;
    dataRangeGroup: string;
    directBilling: string;
    options: string;
    bundlingForm: string;
}

interface AttendanceTypeState {
    attendanceType: AttendanceType[] | any;
    isLoading: boolean
}

const initialState: AttendanceTypeState = {
    attendanceType: [],
    isLoading: false
}

export const attendanceInitialState = createSlice({
    name: "attendanceType",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(getAttendanceType.fulfilled, (state, action: any) => {
            state.attendanceType = action.payload.data
            state.isLoading = false;
        })
            .addCase(getAttendanceType.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAttendanceType.rejected, (state, action) => {
                state.isLoading = false
            })
    }
})

export default attendanceInitialState.reducer